import { Grid2 } from "@mui/material";
import { LinkItem } from "../../../components/model/cardAdministradorModel"
import CardAdministrador from "../../../components/ui/materialui/cardAdministrador";
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import StoreIcon from '@mui/icons-material/Store';
import FeedIcon from '@mui/icons-material/Feed';
import ArchiveIcon from '@mui/icons-material/Archive';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import AssignmentLate from '@mui/icons-material/AssignmentLate';


const Cobranzas: React.FC = () => {

    const linksMutuos: LinkItem[] = [
        { to: "/cobranzas/clientes-cesantes", icon: <PeopleAltIcon sx={{ fontSize: 22, color: "#17c2e6" }} />, text: "Clientes cesantes" },
        { to: "/cobranzas/cobranza-judicial", icon: <StoreIcon sx={{ fontSize: 22, color: "#17c2e6" }} />, text: "Cobranza judicial" },
        { to: "/cobranzas/informeDicom", icon: <FeedIcon sx={{ fontSize: 22, color: "#17c2e6" }} />, text: "Informe DICOM" },
        { to: "/cobranzas/morosos", icon: <AssignmentLate sx={{ fontSize: 22, color: "#17c2e6" }} />, text: "Morosos" },
    ];

    const linksArchivosMasivos: LinkItem[] = [
        { to: "/cobranzas/generarProcesosMasivos", icon: <MoveToInboxIcon sx={{ fontSize: 22, color: "#ACD35E" }} />, text: "Archivo cobranza externa",},
    ];


    return (
        <div>
            <Grid2 container spacing={2} sx={{ mt: 2 }}>

                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                    <CardAdministrador
                        title="Mutuos"
                        icon={<FolderOpenIcon sx={{ fontSize: 20, color: "white" }} />}
                        links={linksMutuos}
                        backgroundColor="#17c2e6"
                        linkTextColor="text-info"
                    />
                </Grid2>

                <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                    <CardAdministrador
                        title="Archivos masivos"
                        icon={<ArchiveIcon sx={{ fontSize: 20, color: "white" }} />}
                        links={linksArchivosMasivos}
                        backgroundColor="#ACD35E"
                        linkTextColor="text-info"
                    />
                </Grid2>

            </Grid2>
        </div>
    )
}

export default Cobranzas;
